export var Routes;

(function (Routes) {
  Routes["All"] = "*";
  Routes["Main"] = "/";
  Routes["Login"] = "/login";
  Routes["UploadContainer"] = "/upload-container";
  Routes["PhoneNumber"] = "/phone";
  Routes["Sms"] = "/otp";
  Routes["Password"] = "/password";
  Routes["Home"] = "/home";
  Routes["Settings"] = "/settings";
  Routes["Pin"] = "/pin";
  Routes["Error"] = "/error";
  Routes["NotFound"] = "/404";
  Routes["HealthCheck"] = "/healthz";
  Routes["Log"] = "/log";
  Routes["Registrars"] = "/registrars";
  Routes["Users"] = "/users";
  Routes["Organizations"] = "/organizations";
})(Routes || (Routes = {}));

export var Flow;

(function (Flow) {
  Flow["SignIn"] = "signIn";
  Flow["SignUp"] = "signUp";
})(Flow || (Flow = {}));